/**
 * Note AI Edit Feature Module
 *
 * Feature configuration for auto-registration
 */

import type { FeatureModule } from '@store/features/types';

import noteAiEditReducer from './chatSlice';
import { noteChatStreamingApi } from './streamingApi';

export const noteAiEditFeature: FeatureModule = {
  id: 'noteAiEdit',
  name: 'Note AI Edit',
  dependencies: [],

  reducers: {
    'noteAiEdit/ui': noteAiEditReducer,
    [noteChatStreamingApi.reducerPath]: noteChatStreamingApi.reducer,
  },

  // P IMPORTANT: This feature adds its own RTK Query middleware
  // because it uses a separate streaming API instance with fakeBaseQuery
  middleware: [noteChatStreamingApi.middleware],

  persistence: {
    enabled: false, // Don't persist streaming state
  },

  sync: {
    enabled: false,
  },

  setup: _store => {
    // Initialization logic if needed
  },

  cleanup: _store => {
    // Cleanup logic if needed
  },
};
